"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@heron-web/material");
var _pickers = require("@material-ui/pickers");
var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _TicketOperatingDaysDatePickerModule = _interopRequireDefault(require("./TicketOperatingDaysDatePicker.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Tickets calendar that highlights/only allows selecting operating days.
 *
 * @param {Object} props
 * @return {ReactNode}
 */
const TicketsOperatingDaysDatePicker = props => {
  const {
    name,
    onChange,
    operatingDays,
    value
  } = props;
  const todayYmd = (0, _react.useMemo)(() => new _moment.default().format("YYYY-MM-DD"), []);

  /**
   * Get whether a particular date should be disabled.
   *
   * We only allow selection of dates where there's a train running.
   *
   * @param {Moment} date
   * @return {Boolean}
   */
  const shouldDisableDate = (0, _react.useCallback)(date => {
    const dateYmd = date.format("YYYY-MM-DD");
    if (!operatingDays) return false;else if (dateYmd === value || dateYmd === todayYmd) return false;else if (!operatingDays?.length) return true;else return !operatingDays.includes(dateYmd);
  }, [operatingDays, todayYmd, value]);

  /**
   * Date changed.
   *
   * @param {String|Null} date
   * @return {void}
   */
  const handleChange = (0, _react.useCallback)(date => {
    if (!date || !shouldDisableDate(date)) {
      onChange(date?.format("YYYY-MM-DD") || null, name);
    }
  }, [name, onChange, shouldDisableDate]);

  /**
   * Date cleared.
   *
   * @return {void}
   */
  const handleClear = (0, _react.useCallback)(() => {
    handleChange(null);
  }, [handleChange]);

  /**
   * Maximum selection date
   */
  const maxDate = operatingDays ? operatingDays?.[operatingDays.length - 1] || todayYmd : undefined;

  /**
   * CSS class string
   */
  const className = [props.className, operatingDays ? _TicketOperatingDaysDatePickerModule.default.mui : undefined, operatingDays && !operatingDays?.includes(todayYmd) ? _TicketOperatingDaysDatePickerModule.default.notOperatingToday : undefined].filter(cls => cls).join(" ");

  /**
   * Render!
   */
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `${props.clearable ? _TicketOperatingDaysDatePickerModule.default.container__clearable : ""} ${className}`.trim(),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_pickers.DatePicker, {
      autoOk: true,
      className: className,
      color: props.color,
      disabled: props.disabled,
      disablePast: true,
      disableToolbar: true,
      emptyLabel: "(Any)",
      initialFocusedDate: props.focusFirstOperatingDay ? operatingDays?.[0] : undefined,
      format: props.format,
      maxDate: maxDate,
      name: name,
      onChange: handleChange,
      shouldDisableDate: shouldDisableDate,
      value: value || (!props.clearable ? todayYmd : null),
      variant: props.variant,
      PopoverProps: {
        className,
        disableScrollLock: true
      }
    }), props.clearable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
      color: props.color,
      disabled: !value && props.clearable || props.disabled,
      icon: _Clear.default,
      onClick: handleClear,
      size: "small",
      tooltip: "Clear"
    })]
  });
};
TicketsOperatingDaysDatePicker.propTypes = {
  className: _propTypes.default.string,
  clearable: _propTypes.default.bool,
  color: _propTypes.default.oneOf(["primary", "secondary"]),
  disabled: _propTypes.default.bool,
  focusFirstOperatingDay: _propTypes.default.bool,
  format: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  operatingDays: _propTypes.default.arrayOf(_propTypes.default.string),
  value: _propTypes.default.string,
  variant: _propTypes.default.oneOf(["inline", "static"])
};
TicketsOperatingDaysDatePicker.defaultProps = {
  clearable: false,
  color: "primary",
  disabled: false,
  focusFirstOperatingDay: false,
  format: "YYYY-MM-DD",
  variant: "static"
};
var _default = TicketsOperatingDaysDatePicker;
exports.default = _default;